<template>
  <div
    class="timer-wrapper"
    :class="validAnswer !== null ? [validAnswer === false ? 'invalid' : 'valid'] : ''"
    :style="{ '--timer-height': height + 'px', '--timer-width': width + 'px' }"
  >
    <div class="timer-container">
      <div class="inner">
        <span :key="timer" class="timer-count">{{ timer }}</span>
        <span class="sec-label">Sek</span>
      </div>
      <div class="left">
        <div
          class="bar"
          :class="{ animate: animate }"
          ref="leftAnimation"
          :style="{
            'animation-duration': timerDelayInSec ? timerDelayInSec / 2 + 's' : initTimer / 2 + 's',
            'animation-play-state': !animate || !hasTimerStart ? 'paused' : '',
          }"
        ></div>
      </div>
      <div class="right">
        <div
          class="bar"
          :class="{ animate: animate }"
          ref="rightAnimation"
          :style="{
            'animation-duration': timerDelayInSec ? timerDelayInSec / 2 + 's' : initTimer / 2 + 's',
            'animation-delay': timerDelayInSec ? timerDelayInSec / 2 + 's' : initTimer / 2 + 's',
            'animation-play-state': !animate || !hasTimerStart ? 'paused' : '',
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/shared/api";
export default {
  name: "Timer",
  props: {
    initTimer: {
      type: Number,
      default: 0,
    },
    hasTimerStart: {
      type: Boolean,
      default: false,
    },
    questionKey: {
      type: String,
      default: null,
    },
    timerHeight: {
      type: Number,
      default: 150,
    },
    timerWidth: {
      type: Number,
      default: 150,
    },
    hasSetTimerAPI: {
      type: Boolean,
      default: true,
    },
    timerDelayInSec: {
      type: Number,
      default: 0,
    },
    validAnswer: {
      type: Boolean | null,
      default: null,
    },
  },
  data() {
    return {
      height: this.timerHeight,
      width: this.timerWidth,
      timer: this.initTimer,
      stopper: null,
      animate: false,
      setTimerAPI: this.hasSetTimerAPI,
    };
  },
  watch: {
    hasTimerStart: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.animate = false;
          setTimeout(() => this.startTimer(), 10);
        } else {
          this.stopTimer();
          if (oldVal !== undefined) this.$emit('clickAnswer');
        }
      },
      immediate: true,
    },
  },
  methods: {
    triggerInterval() {
      this.stopper = setInterval(() => {
        this.timer--;
        this.$emit('getTimer', this.timer);
        if (this.timer <= 0) {
          this.stopTimer();
          this.$emit('clickAnswer', true);
        }
      }, ((this.timerDelayInSec * 1000)/this.initTimer) || 1000);
    },
    startTimer() {
      this.timer = this.initTimer;
      this.stopTimer();
      if (this.setTimerAPI) {
        API.meInstance.get("/set_quizz_time").then(() => {
          this.animate = true;
          this.$emit('hasStartCbk');
          this.triggerInterval()
        });
      } else {
        this.animate = true;
        this.$emit('hasStartCbk');
        this.triggerInterval()
      }
    },
    stopTimer() {
      clearInterval(this.stopper);
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes left {
  0% {
    transform: rotateZ(360deg);
  }
  100% {
    transform: rotateZ(180deg);
  }
}
@keyframes right {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(-180deg);
  }
}
.timer-wrapper {
  --timer-height: 150px;
  --timer-width: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  .timer-container {
    border-radius: 100%;
    width: var(--timer-width);
    height: var(--timer-height);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
    overflow: hidden;
    &::before {
      content: "";
      position: absolute;
      height: 100%;
      width: 100%;
      border: 2px solid #c4c4c4;
      border-radius: 100%;
      transform: scale(0.96);
      z-index: -3;
    }
    .left {
      position: absolute;
      left: 0;
      width: 50%;
      height: var(--timer-height);
      z-index: -2;
      background: transparent;
      overflow: hidden;
      .bar {
        position: absolute;
        left: 0;
        height: 100%;
        width: var(--timer-width);
        clip: rect(0, calc(var(--timer-height) / 2), var(--timer-height), 0);
        border-radius: 50%;
        &.animate {
          background: #fcbd00;
          animation-name: left;
          animation-timing-function: linear;
          animation-fill-mode: forwards;
        }
      }
    }
    .right {
      position: absolute;
      right: 0;
      width: 50%;
      height: var(--timer-height);
      z-index: -1;
      background: transparent;
      overflow: hidden;
      .bar {
        position: absolute;
        right: 0;
        height: 100%;
        width: var(--timer-width);
        clip: rect(
          0,
          var(--timer-width),
          var(--timer-height),
          calc(var(--timer-height) / 2)
        );
        border-radius: 100%;
        &.animate {
          background: #fcbd00;
          animation-name: right;
          animation-timing-function: linear;
          animation-fill-mode: forwards;
        }
      }
    }
    .inner {
      background: #f8f8f8;
      border-radius: 100%;
      height: calc(var(--timer-height) - 15px);
      width: calc(var(--timer-width) - 15px);
      overflow: hidden;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .timer-count {
        font-size: 42px;
        line-height: 1;
      }
      span:last-child {
        font-weight: 400;
        font-size: 14px;
        line-height: 1.32;
      }
    }
  }
  &.valid {
    .timer-container {
      .left .bar.animate, .right .bar.animate {
        background: #2EC3B5;
      }
    }
  }
  &.invalid {
    .timer-container {
      .left .bar.animate, .right .bar.animate {
        background: #FF6A6A;
      }
    }
  }
}
</style>
